import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import ShortText from './ShortText'
import Email from './Email'
import Phone from './Phone'
import MultiChoice from './MultiChoice'
import LongText from './LongText'

const SponsorshipRequestForm = () => {


    const sponsorshipData = [
        {
            id: 1,
            label: 'حامی اول',
            checked: false
        },
        {
            id: 2,
            label: 'حامی دوم',
            checked: false
        },
        {
            id: 3,
            label: 'حامی سوم',
            checked: false
        },

    ]


    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'درخواست حمایت مالی'} subHeader={''} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <ShortText header={'شرکت'}/>
                <Email header={'ایمیل'}/>
                <Phone header={'شماره تلفن'}/>
                <MultiChoice header={'حمایت مالی'} options={sponsorshipData}/>
                <LongText header={'نظرات'}/>
            </Grid>
        </Grid>
    )
}

export default SponsorshipRequestForm
